/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Code_SplittingInputs */

const en_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code splitting`)
};

const ar_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقسيم الكود`)
};

const bn_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোড স্প্লিটিং`)
};

const de_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codeaufteilung`)
};

const es_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`División de código`)
};

const fr_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fractionnement des codes`)
};

const pt_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisão de código`)
};

const zh_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代码分割`)
};

const tr_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kod bölme`)
};

const ru_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разделение кода`)
};

const pl_svchip_code_splitting = /** @type {(inputs: Svchip_Code_SplittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podział kodu`)
};

/**
* | output |
* | --- |
* | "Code splitting" |
*
* @param {Svchip_Code_SplittingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_code_splitting = /** @type {((inputs?: Svchip_Code_SplittingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Code_SplittingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_code_splitting(inputs)
	if (locale === "bn") return bn_svchip_code_splitting(inputs)
	if (locale === "de") return de_svchip_code_splitting(inputs)
	if (locale === "es") return es_svchip_code_splitting(inputs)
	if (locale === "fr") return fr_svchip_code_splitting(inputs)
	if (locale === "pt") return pt_svchip_code_splitting(inputs)
	if (locale === "zh") return zh_svchip_code_splitting(inputs)
	if (locale === "tr") return tr_svchip_code_splitting(inputs)
	if (locale === "ru") return ru_svchip_code_splitting(inputs)
	if (locale === "pl") return pl_svchip_code_splitting(inputs)
	return en_svchip_code_splitting(inputs)
});